import { module } from 'stereomodularjs';

export default class extends module {
	constructor(m) {
		super(m);
		this.dialog = document.querySelector(".js-modal");
		this.showButton = this.el;
		this.closeButton = document.querySelector(".js-modal-close");
		this.modalContent = document.querySelectorAll('[data-modal="content"]');
		this.overlayPanel = document.querySelector(this.el.getAttribute('data-modal'));
		this.overlayVideo = document.querySelector('.js-modal-video');
	}

	init() {
		// "Show the dialog" button opens the dialog modally
		this.showButton.addEventListener("click", () => {
			// Hide all other modals items
			this.modalContent.forEach(content => {
				content.classList.remove('is-active');
			});
			// Show the current modal item
			this.overlayPanel.classList.add('is-active');
			// Set video content
			if (this.el.getAttribute('data-video')) {
				let overlayVideo = this.el.getAttribute('data-video');
				this.overlayVideo.innerHTML = overlayVideo;
			}
			this.dialog.showModal();
		});

		// "Close" button closes the dialog
		this.closeButton.addEventListener("click", this.closeDialog.bind(this));

		// Clicking the backdrop closes the dialog
		this.dialog.addEventListener("click", (event) => {
			if (event.target === this.dialog) {
				this.closeDialog();
			}
		});
	}

	closeDialog(event) {
		if (event) {
			event.stopPropagation();
		}

		this.dialog.setAttribute("closing", "");

		this.dialog.addEventListener(
			"animationend",
			() => {
				this.dialog.removeAttribute("closing");
				this.dialog.close();
				this.overlayVideo.innerHTML = '';
			},
			{
				once: true
			}
		);
	}

	destroy() {
        this.showButton.removeEventListener('click', this.openModal);
		this.closeButton.removeEventListener('click', this.closeModal);
		this.dialog.removeEventListener('click', this.closeModal);

        if (this.overlayVideo) {
            this.overlayVideo.innerHTML = '';
        }
    }
}
